export default {
  lazada: process.env.REACT_APP_LAZADA_ACCOUNT,
  jd: process.env.REACT_APP_JD_ACCOUNT,
  shopee: process.env.REACT_APP_SHOPEE_ACCOUNT,
};
